import React, { Component } from 'react';
import { Navbar, Nav } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import setPrintPDFAction from '../redux/actions/showReferenceActions/actionPDFPrint';
import setSearchReferencesDataAction from '../redux/actions/searchReferenceActions/actionSearchReferencesData';
import { connect } from 'react-redux'

class MenuBar extends Component {
  constructor(props) {
    super(props)
    this.state = {navExpanded: false, firm: localStorage.getItem("firm")}
    this.closeNav = this.closeNav.bind(this);
    this.closeNavMap = this.closeNavMap.bind(this);
    this.setNavExpanded = this.setNavExpanded.bind(this);
  }

  setNavExpanded() {
    if(this.state.navExpanded === true) {
      this.setState({navExpanded: false})
    } else {
      this.setState({navExpanded: true})
    }
   }

  closeNav() {
    this.setState({navExpanded: false})
  }

  closeNavMap() {
    this.setState({navExpanded: false})
    this.props.setPrintPDFFunction('');
    this.props.setSearchReferencesDataFunction('');
  }

  render() {

    const { t } = this.props;
    const brandStyle = {
      marginLeft: '10px' // Fügen Sie hier den gewünschten linken Abstand hinzu
    };

    return (
      <div className="createMenuClass">
        
        <Navbar expanded={this.state.navExpanded} onToggle={this.setNavExpanded} className ='mc-navbar' expand="lg" variant="dark">
        <Navbar.Brand style={brandStyle}>{this.state.firm === "001" ? "MC-Bauchemie" : "Botament"}</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
       
        <Nav className ='mc-nav' > 
            <Link onClick={this.closeNav} className="mc-navbarlink" to ="/home" style={{ textDecoration: 'none' }}> {t("menu.home")}</Link>
            <Link onClick={this.closeNav} className="mc-navbarlink" to ="/createRef" style={{ textDecoration: 'none' }}> {t("menu.create_ref")}</Link>
            <Link onClick={this.closeNav} className="mc-navbarlink" to ="/searchRef" style={{ textDecoration: 'none' }}> {t("menu.search_ref")}</Link>
            <Link onClick={this.closeNavMap} className="mc-navbarlink" to ="/viewMap" style={{ textDecoration: 'none' }}>  {t("menu.map")}</Link>
            <Link onClick={this.closeNav} className="mc-navbarlink" to ="/" style={{ textDecoration: 'none' }}> {t("menu.logout")}</Link>
        </Nav>
       
        </Navbar.Collapse>
      </Navbar>
      </div>
    )
  }
}

function mapDispatchToProps(dispatch) {
  return {
      setPrintPDFFunction: pdfPrintData => {
          dispatch(setPrintPDFAction(pdfPrintData))
      }, 
      setSearchReferencesDataFunction: referencesData => {
        dispatch(setSearchReferencesDataAction(referencesData))
      }
  }
}

export default connect(null,mapDispatchToProps)(withTranslation()(MenuBar));

// MenuBar
// export default withTranslation()(MenuBar);